/* eslint-disable import/prefer-default-export */
export const CARD_MSG_CODE = [600, 601, 602, 603, 608, 609, 610, 613];

export const MARKET_OFFER_TYPE = {
  COUPON: 1,
  CARD: 2,
  COIN: 3,
  RED: 4,
  GIFT: 5,
};

// 页面加载状态
export const PAGE_LOAD_STATUS = {
  LOADING: 'LOADING',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
};

// 头部组件图标
export const BLACK_LEFT_ICON = 'https://m.hellobike.com/resource/helloyun/884f8718adcd400ea0401429476f2449/a1b25d20-c418-4ce0-9d0a-1c141af18707.svg';
export const WHITE_LEFT_ICON = 'https://m.hellobike.com/resource/helloyun/884f8718adcd400ea0401429476f2449/1a8e6b8d-4e61-40ae-b0bc-0d2687f926a5.svg';
